import * as types from '../../types';
import { showMessage } from '..';

import reportService from '../../../services/ReportService';
import universeService from '../../../services/UniverseService';

const formatPostData = (data) => {
  return {
    ...data,
    selectedModels: data?.selectedModels?.map((model) => (model?.id ? model.id : model)) || [],
  };
};
// Reporting Output save
export const saveRankingReportingOutput = (data, id) => async (dispatch) => {
  try {
    const type = 'rankingReport';
    const formatedData = formatPostData(data);

    const result = await reportService.saveRankingReportSpec(formatedData, id, type);

    if (result?.error) {
      dispatch(showMessage({ type: 'error', message: result.error?.detail }));
    } else {
      const { spec, ...rest } = result;

      dispatch(showMessage({ type: 'success', message: 'Data saved successfully.' }));
      dispatch({
        type: types.RANKING_REPORTING_OUTPUT_SAVE_DATA,
        payload: { ...spec, ...rest },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const saveRankingReportingOutputInState = (data) => async (dispatch) => {
  dispatch({
    type: types.RANKING_REPORTING_OUTPUT_SAVE_DATA_IN_STATE,
    payload: data,
  });
};

export const resetRankingReportingOutput = () => (dispatch) => {
  dispatch({
    type: types.RANKING_REPORTING_OUTPUT_RESET,
    payload: '',
  });
};

export const deleteRankingReportingOutput = (id) => async (dispatch) => {
  try {
    await universeService.deleteUniverse(id);
    dispatch(resetRankingReportingOutput());
    dispatch(showMessage({ type: 'success', message: 'Data deleted successfully.' }));
  } catch (error) {}
};

// Load Data
export const loadRankingReportingOutput = (id) => async (dispatch) => {
  const result = await reportService.loadRankingReportSpec(id);

  const { spec, ...rest } = result;

  dispatch({
    type: types.RANKING_REPORTING_OUTPUT_LOAD_DATA,
    payload: { ...spec, ...rest },
  });

  dispatch(showMessage({ type: 'success', message: 'Data loaded successfully.' }));
};

export const updateRankingSelectedModels = (models) => (dispatch) => {
  dispatch({
    type: types.RANKING_REPORTING_OUTPUT_UPDATE_SELECTED_MODELS,
    payload: models,
  });
};

export const updateRankingModels = (specModel, models) => (dispatch) => {
  dispatch({
    type: types.RANKING_REPORTING_OUTPUT_UPDATE_MODELS,
    payload: { specModel, models },
  });
};
